import { Link } from "react-router-dom";
// import HeroImg from "../../assets/images/public-pages/pte-core.png";
import FameWallNaati from "components/Frontend/FameWallNaati";
import '../../assets/css/public-pages.css'
import ReusableHomePageSlider from "page/ReusableHomePageSlider";
import ButtonComp from "./ButtonComp";

const BannerHeader = (props) => {
  const { title, subTitle, blueBoxText, hideFameWall, videoId, backgroundColor, textColor, HeroImg, middleSection , btnText, backgroundImage } = props;

  return (
    <div className="banner-header noc-banner" style={{ "--banner-color": backgroundColor || '#182A4F', "--banner-text-color": textColor || 'white', ...(backgroundImage ? { backgroundImage: `url(${backgroundImage})`, backgroundRepeat: 'no-repeat' } : {}) }}>
      <div className="container">
        <div className="row">
          <div className="banner-content">
            <div className="d-flex align-items-center text-center flex-column gap-4">
              <div className="students-stat mb-4">
                <p className="FS18FW400 fw-600 mb-0">50,000+ Students Dreams Turned into Success</p>
              </div>
              {title && title()}
              {subTitle && subTitle()}
              <ButtonComp link={props.btnLink } btnText={btnText ? btnText : "Register For Preparation Now"} className={`${props.className || ''} mt-2`} />
            </div>

            {middleSection && middleSection()}

          </div>
        </div>
      </div>
    </div>)
};
export default BannerHeader;